module.exports = __webpack_public_path__ + "img/verified-fill.0840e688.svg";